<template>
    <div v-if="!isOverview"
         :class="['bto-sb-event-sports',  {'bto-sb-event-sports-slide': Object.keys(getSports).length > scrollTriger}]">
        <div class="bto-sb-event-more-sports bto-sb-event-more-sports-left" v-show="Object.keys(getSports).length > scrollTriger">
            <a @click="sideScroll('left')"></a>
        </div>
        <ul :class="{'sport-list': Object.keys(getSports).length > scrollTriger}" ref="sportlist">
            <li v-for="sport in getSports" :key="sport.id"
                @click.prevent="changeSport(sport.id)"
                :class="{'bto-sb-event-sports-active': sport.id === selectedSport}">
                <span class="bto-sb-sports-icon" :class="sport.class"></span><a href="#">{{ sport.name }}</a>
            </li>
        </ul>
        <div class="bto-sb-event-more-sports bto-sb-event-more-sports-right" v-show="sports.length > scrollTriger">
            <a @click="sideScroll('right')"></a>
        </div>
    </div>

    <div v-else class="bto-sb-widget bto-sb-widget-overviewmenu">
        <div class="bto-sb-widget-content">
            <ul>
                <li @click.prevent="openFavorites()"
                    :class="{'bto-sb-event-sports-active': favoritesOpen}">
                    <span class="bto-sb-sports-icon sports-star"></span>
                    <a>{{t('Mobile.Favorites')}}</a>
                </li>
                <li v-for="sport in getSports" :key="sport.id"
                    @click.prevent="changeSport(sport.id)"
                    :class="{'bto-sb-event-sports-active': !favoritesOpen && sport.id === selectedSport}">
                    <span class="bto-sb-sports-icon" :class="sport.class"></span>
                    <a>{{sport.name}}</a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
  import store from '../../../store/index';

  export default {
    name: 'SportsListComponent',
    data() {
      return {
        sportSelectorMoveDistance: 16, // how many pixels selector will move on each click in both directions
      };
    },
    props: {
      /**
       * here we can have filtered sport ids that we want to appear in the selector list
       * in case of live matches we will use this prop as we want to show only sports that have live matches
       */
      sports: {
        type: [Array, Object],
        default: () => [],
      },
      /**
       * we will also pass selected sport if we know which one will be selected as default
       */
      selectedSport: {
        type: [Number, String],
        default: 0
      },
      /**
       * different template for live now (overview) page
       */
      isOverview: {
        type: Boolean,
        required: false,
        default: false,
      },
      /**
       *
       */
      favoritesOpen: {
        type: Boolean,
        required: false,
        default: false,
      },
      scrollTriger: {
        type: Number,
        default: 4,
      },
      /**
       * Flag wheather to filter the sports or use raw
       */
      useRawSports: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      /**
       * We will get all sports data from store
       * @returns {*}
       */
      getSports() {
        if (this.useRawSports) {
          return this.sports;
        }
        const allSportData = store.state.SportsModule.allSportsData;
        if (this.sports.length > 0) {
          let filteredSportData = [];
          this.sports.forEach((sportId) => {
            let filteredSport = {};
            filteredSport = Object.values(allSportData).filter((el) => {
              return el.id === Number(sportId);
            });
            filteredSportData.push(...filteredSport);
          });
          const sports = filteredSportData.map((sports, curr) => {
            sports[curr] = filteredSportData[curr];
            return sports;
          }, {});
          return sports;
        }
        return [];
      },
    },
    created() {
      store.dispatch('getAllSportData');
    },
    methods: {
      /**
       * Change sport when clicked on each sport
       */
      changeSport(sportId) {
        this.$emit('changeSport', sportId);
        // Store data in window dataLayer for GTM
        window.dataLayer.push({
          event: 'sport_selected',
          sport_name: store.getters.getSportName(sportId),
          PID: APP_SETTINGS.player.id,
        });
      },
      /**
       *  horizontal scroll on click
       */
      sideScroll(direction) {
        let element = this.$refs.sportlist;
        let stepWidth = element.offsetWidth / 3;
        let directionStep = direction === 'right' ? element.scrollLeft + stepWidth : element.scrollLeft - stepWidth;
        this.scrollTo(element, directionStep, direction);
      },
      /**
       * Animate scrolling
       * @param element
       * @param to
       * @param direction
       */
      scrollTo(element, to, direction) {
        if (to < 0) {
          to = 0;
        }
        const maxScrollLeft = element.scrollWidth - element.offsetWidth;
        if (to >= maxScrollLeft) {
          to = maxScrollLeft;
        }
        let reqAnim = 0;
        const tick = () => {
          element.scrollLeft = direction === 'right' ?
            element.scrollLeft + this.sportSelectorMoveDistance :
            element.scrollLeft - this.sportSelectorMoveDistance;
          if ((direction === 'right' && element.scrollLeft < to) || (direction === 'left' && element.scrollLeft > to)) {
            reqAnim = requestAnimationFrame(tick);
          } else {
            cancelAnimationFrame(reqAnim);
          }
        };
        reqAnim = requestAnimationFrame(tick);
      },
      openFavorites() {
        this.$emit('openFavorites');
      },
    }
  };
</script>
<style scoped>
  div.bto-sb-event-more-sports {
    z-index: 100;
  }

  ul.sport-list {
    padding-left: 30px;
    max-width: calc(100% - 30px);
  }
</style>
